








import { Vue, Component, Prop } from 'vue-property-decorator';
import { CouponAdConf } from '@/types/we-coupons';
import { ShareCouponSmall } from '@tencent/wphk-components-help-friend';

@Component({
  components: {
    ShareCouponSmall,
  },
})
export default class CouponAd extends Vue {
  /** 广告位信息 */
  @Prop() adInfo!: CouponAdConf;

  /** 点击广告 */
  async handleClickAd() {
    this.$emit('click');
  }
}
